import {AgeniumUser} from '@amplify/athena-models';
import {IS_PRODUCTION} from '../../constants';
import {AgeniumAgentDetail} from './types';

// FIX: Should this be stored in Dynamo??
export const agentsDetail = {
    other: {
        Case_Agent_KeyedContractNumber: '6016101',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '6016101',
        Case_Agent_KeyedFirstName: 'Seymour',
        Case_Agent_KeyedLastName: 'Data',
    },
    alank: {
        Case_Agent_KeyedContractNumber: '12901563',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '12901563',
        Case_Agent_KeyedFirstName: 'Alan',
        Case_Agent_KeyedLastName: 'Klitenic',
    },
    albertd: {
        Case_Agent_KeyedContractNumber: '17746552',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '17746552',
        Case_Agent_KeyedFirstName: 'Albert',
        Case_Agent_KeyedLastName: 'Dabney',
    },
    alvind: {
        Case_Agent_KeyedContractNumber: '9263774',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '9263774',
        Case_Agent_KeyedFirstName: 'Alvin',
        Case_Agent_KeyedLastName: 'Dawkins',
    },
    alyssas: {
        Case_Agent_KeyedContractNumber: '20741196',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20741196',
        Case_Agent_KeyedFirstName: 'Alyssa',
        Case_Agent_KeyedLastName: 'Silas',
    },
    amandat: {
        Case_Agent_KeyedContractNumber: '20521094',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20521094',
        Case_Agent_KeyedFirstName: 'Amanda',
        Case_Agent_KeyedLastName: 'Traylor',
    },
    angelaf: {
        Case_Agent_KeyedContractNumber: '7542384',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '7542384',
        Case_Agent_KeyedFirstName: 'Angela',
        Case_Agent_KeyedLastName: 'Foxworth',
    },
    angelan: {
        Case_Agent_KeyedContractNumber: '9711091',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '9711091',
        Case_Agent_KeyedFirstName: 'Angela',
        Case_Agent_KeyedLastName: 'Newsom',
    },
    anthonyd: {
        Case_Agent_KeyedContractNumber: '18560777',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '18560777',
        Case_Agent_KeyedFirstName: 'Anthony',
        Case_Agent_KeyedLastName: 'DeVito',
    },
    ared: {
        Case_Agent_KeyedContractNumber: '7493021',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '7493021',
        Case_Agent_KeyedFirstName: 'Ana',
        Case_Agent_KeyedLastName: 'Red',
    },
    arlened: {
        Case_Agent_KeyedContractNumber: '20248906',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20248906',
        Case_Agent_KeyedFirstName: 'Arlene',
        Case_Agent_KeyedLastName: 'Delemos',
    },
    ashleya: {
        Case_Agent_KeyedContractNumber: '20312219',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20312219',
        Case_Agent_KeyedFirstName: 'Ashley',
        Case_Agent_KeyedLastName: 'Alicea-Ramirez',
    },
    aunderwood: {
        Case_Agent_KeyedContractNumber: '20653545',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20653545',
        Case_Agent_KeyedFirstName: 'Alexandria',
        Case_Agent_KeyedLastName: 'Underwood',
    },
    barryr: {
        Case_Agent_KeyedContractNumber: '9887348',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '9887348',
        Case_Agent_KeyedFirstName: 'Barry',
        Case_Agent_KeyedLastName: 'Rose',
    },
    bodaiw: {
        Case_Agent_KeyedContractNumber: '18975934',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '18975934',
        Case_Agent_KeyedFirstName: 'Bodai',
        Case_Agent_KeyedLastName: 'Williams',
    },
    charlesp: {
        Case_Agent_KeyedContractNumber: '16217040',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '16217040',
        Case_Agent_KeyedFirstName: 'Charles',
        Case_Agent_KeyedLastName: 'Perault',
    },
    chelseyd: {
        Case_Agent_KeyedContractNumber: '21338215',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '21338215',
        Case_Agent_KeyedFirstName: 'Chelsea',
        Case_Agent_KeyedLastName: 'Dousis',
    },
    collinr: {
        Case_Agent_KeyedContractNumber: '19284533',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '19284533',
        Case_Agent_KeyedFirstName: 'Collin',
        Case_Agent_KeyedLastName: 'Ramsdell',
    },
    cyrusb: {
        Case_Agent_KeyedContractNumber: '19237034',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '19237034',
        Case_Agent_KeyedFirstName: 'Cyrus',
        Case_Agent_KeyedLastName: 'Bigham',
    },
    daniels: {
        Case_Agent_KeyedContractNumber: '16094424',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '16094424',
        Case_Agent_KeyedFirstName: 'Daniel',
        Case_Agent_KeyedLastName: 'Stoebling',
    },
    davidd: {
        Case_Agent_KeyedContractNumber: '2602639',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '2602639',
        Case_Agent_KeyedFirstName: 'David',
        Case_Agent_KeyedLastName: 'Dixson',
    },
    davidm: {
        Case_Agent_KeyedContractNumber: '15490538',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '15490538',
        Case_Agent_KeyedFirstName: 'David',
        Case_Agent_KeyedLastName: 'Mulvey',
    },
    desmondp: {
        Case_Agent_KeyedContractNumber: '1920498',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '1920498',
        Case_Agent_KeyedFirstName: 'Desmond',
        Case_Agent_KeyedLastName: 'Primus',
    },
    dolorest: {
        Case_Agent_KeyedContractNumber: '20766380',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20766380',
        Case_Agent_KeyedFirstName: 'Dolores',
        Case_Agent_KeyedLastName: 'Torry',
    },
    gleigh: {
        Case_Agent_KeyedContractNumber: '18940757',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '18940757',
        Case_Agent_KeyedFirstName: 'Gina',
        Case_Agent_KeyedLastName: 'Leigh',
    },
    hanna: {
        Case_Agent_KeyedContractNumber: '17255035',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '17255035',
        Case_Agent_KeyedFirstName: 'Hanna',
        Case_Agent_KeyedLastName: 'Wu',
    },
    haroldh: {
        Case_Agent_KeyedContractNumber: '10382902',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '10382902',
        Case_Agent_KeyedFirstName: 'Harold',
        Case_Agent_KeyedLastName: 'Hobbs',
    },
    jake: {
        Case_Agent_KeyedContractNumber: '8234352',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '8234352',
        Case_Agent_KeyedFirstName: 'Jacob',
        Case_Agent_KeyedLastName: 'Dobbins',
    },
    jamilc: {
        Case_Agent_KeyedContractNumber: '19339461',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '19339461',
        Case_Agent_KeyedFirstName: 'Jamil',
        Case_Agent_KeyedLastName: 'Crossland',
    },
    janellej: {
        Case_Agent_KeyedContractNumber: '9416907',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '9416907',
        Case_Agent_KeyedFirstName: 'Janelle',
        Case_Agent_KeyedLastName: 'Jackson',
    },
    jennifera: {
        Case_Agent_KeyedContractNumber: '20190674',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20190674',
        Case_Agent_KeyedFirstName: 'Jennifer',
        Case_Agent_KeyedLastName: 'Atkins',
    },
    jeridf: {
        Case_Agent_KeyedContractNumber: '12388041',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '12388041',
        Case_Agent_KeyedFirstName: 'Jerid',
        Case_Agent_KeyedLastName: 'Ferranti',
    },
    jodyc: {
        Case_Agent_KeyedContractNumber: '20617037',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20617037',
        Case_Agent_KeyedFirstName: 'Jody',
        Case_Agent_KeyedLastName: 'Chappel',
    },
    joeyo: {
        Case_Agent_KeyedContractNumber: '20359983',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20359983',
        Case_Agent_KeyedFirstName: 'Joey',
        Case_Agent_KeyedLastName: 'Otradovec',
    },
    jonathane: {
        Case_Agent_KeyedContractNumber: '17142211',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '17142211',
        Case_Agent_KeyedFirstName: 'Jonathan',
        Case_Agent_KeyedLastName: 'Elieff',
    },
    jtrexler: {
        Case_Agent_KeyedContractNumber: '16706115',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '16706115',
        Case_Agent_KeyedFirstName: 'Jennifer',
        Case_Agent_KeyedLastName: 'Trexler',
    },
    kevenw: {
        Case_Agent_KeyedContractNumber: '8507080',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '8507080',
        Case_Agent_KeyedFirstName: 'Keven',
        Case_Agent_KeyedLastName: 'Wilson',
    },
    knowland: {
        Case_Agent_KeyedContractNumber: '7764273',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '7764273',
        Case_Agent_KeyedFirstName: 'Knowlan',
        Case_Agent_KeyedLastName: 'Dawson',
    },
    korinne: {
        Case_Agent_KeyedContractNumber: '18761951',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '18761951',
        Case_Agent_KeyedFirstName: 'Korinne',
        Case_Agent_KeyedLastName: 'Vegvary',
    },
    lyrich: {
        Case_Agent_KeyedContractNumber: '20511276',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20511276',
        Case_Agent_KeyedFirstName: 'Lyric',
        Case_Agent_KeyedLastName: 'Hodges',
    },
    nickr: {
        Case_Agent_KeyedContractNumber: '6842839',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '6842839',
        Case_Agent_KeyedFirstName: 'Nick',
        Case_Agent_KeyedLastName: 'Rackham',
    },
    nicolew: {
        Case_Agent_KeyedContractNumber: '18524313',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '18524313',
        Case_Agent_KeyedFirstName: 'Nicole',
        Case_Agent_KeyedLastName: 'Whelan',
    },
    omidk: {
        Case_Agent_KeyedContractNumber: '8354669',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '8354669',
        Case_Agent_KeyedFirstName: 'Omid',
        Case_Agent_KeyedLastName: 'Kamali',
    },
    randolphk: {
        Case_Agent_KeyedContractNumber: '1914035',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '1914035',
        Case_Agent_KeyedFirstName: 'Randolph',
        Case_Agent_KeyedLastName: 'Kennedy',
    },
    rashadx: {
        Case_Agent_KeyedContractNumber: '7986515',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '7986515',
        Case_Agent_KeyedFirstName: 'Rashad',
        Case_Agent_KeyedLastName: 'Xi Amaru',
    },
    rformanek: {
        Case_Agent_KeyedContractNumber: '9931550',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '9931550',
        Case_Agent_KeyedFirstName: 'Robert',
        Case_Agent_KeyedLastName: 'Formanek',
    },
    richardb: {
        Case_Agent_KeyedContractNumber: '17038213',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '17038213',
        Case_Agent_KeyedFirstName: 'Richard',
        Case_Agent_KeyedLastName: 'Bush',
    },
    robertt: {
        Case_Agent_KeyedContractNumber: '7409132',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '7409132',
        Case_Agent_KeyedFirstName: 'Robert',
        Case_Agent_KeyedLastName: 'Twombly',
    },
    rondettaw: {
        Case_Agent_KeyedContractNumber: '20050733',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20050733',
        Case_Agent_KeyedFirstName: 'Rondetta',
        Case_Agent_KeyedLastName: 'Watts',
    },
    rustya: {
        Case_Agent_KeyedContractNumber: '17770534',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '17770534',
        Case_Agent_KeyedFirstName: 'Rusty',
        Case_Agent_KeyedLastName: 'Arnold',
    },
    samanthal: {
        Case_Agent_KeyedContractNumber: '20220546',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20220546',
        Case_Agent_KeyedFirstName: 'Samantha',
        Case_Agent_KeyedLastName: 'Lewis',
    },
    saraif: {
        Case_Agent_KeyedContractNumber: '9986147',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '9986147',
        Case_Agent_KeyedFirstName: 'Sarai',
        Case_Agent_KeyedLastName: 'Ferranti',
    },
    scottp: {
        Case_Agent_KeyedContractNumber: '17275603',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '17275603',
        Case_Agent_KeyedFirstName: 'Scott',
        Case_Agent_KeyedLastName: 'Pressman',
    },
    shamirl: {
        Case_Agent_KeyedContractNumber: '16328200',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '16328200',
        Case_Agent_KeyedFirstName: 'Shamir',
        Case_Agent_KeyedLastName: 'Long',
    },
    sheryl: {
        Case_Agent_KeyedContractNumber: '18526906',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '18526906',
        Case_Agent_KeyedFirstName: 'Sheryl',
        Case_Agent_KeyedLastName: 'Rauzi',
    },
    sophier: {
        Case_Agent_KeyedContractNumber: '5315311',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '5315311',
        Case_Agent_KeyedFirstName: 'Sophie',
        Case_Agent_KeyedLastName: 'Russell',
    },
    stephaniec: {
        Case_Agent_KeyedContractNumber: '20303390',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20303390',
        Case_Agent_KeyedFirstName: 'Stephanie',
        Case_Agent_KeyedLastName: 'Crider',
    },
    thomasz: {
        Case_Agent_KeyedContractNumber: '20598324',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '20598324',
        Case_Agent_KeyedFirstName: 'Thomas',
        Case_Agent_KeyedLastName: 'Zornes',
    },
    vincentf: {
        Case_Agent_KeyedContractNumber: '10696115',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '10696115',
        Case_Agent_KeyedFirstName: 'Vincent',
        Case_Agent_KeyedLastName: 'Ciminera',
    },
    zacharyu: {
        Case_Agent_KeyedContractNumber: '17593931',
        Case_AgentReport_AgentAssisted: 'Yes',
        Case_AgentReport_AgentAssistedContractNumber: '17593931',
        Case_Agent_KeyedFirstName: 'Zachary',
        Case_Agent_KeyedLastName: 'Uhiren',
    },
};

export const agentDetailKeys = new Set([
    'Case_Agent_KeyedContractNumber',
    'Case_AgentReport_AgentAssisted',
    'Case_AgentReport_AgentAssistedContractNumber',
    'Case_Agent_KeyedFirstName',
    'Case_Agent_KeyedLastName',
]);

export const anonymousAgent = {
    Case_Agent_KeyedContractNumber: '6016101',
    Case_AgentReport_AgentAssisted: 'Yes' as 'Yes' | 'No',
    Case_AgentReport_AgentAssistedContractNumber: '6016101',
    Case_Agent_KeyedFirstName: 'Seymour',
    Case_Agent_KeyedLastName: 'Data',
};

export const getAgentDetail = (ageniumUser: AgeniumUser): AgeniumAgentDetail | null => {
    if (ageniumUser) {
        return {
            Case_Agent_KeyedContractNumber: ageniumUser.keyedContractNumber,
            Case_AgentReport_AgentAssisted: ageniumUser.agentAssisted ? 'Yes' : 'No',
            Case_AgentReport_AgentAssistedContractNumber: ageniumUser.agentAssistedContractNumber,
            Case_Agent_KeyedFirstName: ageniumUser.agentKeyedFirstName,
            Case_Agent_KeyedLastName: ageniumUser.agentKeyedLastName,
        };
    } else {
        return !IS_PRODUCTION ? anonymousAgent : null;
    }
};

export const getAgentDetailBasedOnName = (name: string) => {
    const agentNameSplit = name.split(' ');
    const agentFirstName = agentNameSplit[0];
    const agentLastName = agentNameSplit[1];
    for (const key in agentsDetail) {
        const agentDetail = agentsDetail[key as keyof typeof agentsDetail];
        if (
            agentDetail.Case_Agent_KeyedFirstName == agentFirstName &&
            agentDetail.Case_Agent_KeyedLastName == agentLastName
        ) {
            return agentDetail;
        }
    }
};
